import React, { useRef } from 'react'

import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { AsyncSelectControl } from '../../../../components/AsyncSelectControl'
import { SelectedUser } from '../SelectedUser'

export default function UserLookup({
  existingUser,
  setExistingUser,
  setInitialExistingUser,
  loadExistingUsers,
  setStep,
  setUserType,
}) {
  const inputRef = useRef()

  const handleExistingUser = (selected) => {
    if (selected) {
      if (existingUser) {
        // set initial state to previous existing user
        setInitialExistingUser(existingUser)
      } else {
        // if no previous existing user (first time), set to new existing user
        setInitialExistingUser(selected)
      }
      // Keep lookup on the existing-user path so Next enables and assignTo is filled
      setUserType('existing-user')
      setExistingUser(selected)
      return
    }

    // Cleared selection
    setExistingUser()
    setInitialExistingUser()
  }

  const handleClick = () => {
    setStep(1)
    setUserType('new-user')
  }

  const getNoOptionsMessage = () => {
    if (!inputRef.current) return 'No users found'
    return (
      <div className="d-flex split-row">
        <span>No users found</span>
        <Button
          variant="link"
          size="sm"
          className="icon-button--link icon-button-lg btn-plus"
          onClick={handleClick}
        >
          Continue with new account
        </Button>
      </div>
    )
  }

  return (
    <Stack gap={4}>
      <AsyncSelectControl
        placeholder="Search by name, phone number or email"
        loadUsers={loadExistingUsers}
        existingUser={existingUser}
        onChange={handleExistingUser}
        noOptionsMessage={getNoOptionsMessage}
        defaultUser={existingUser}
        inputRef={inputRef}
      />
      <div className="d-flex justify-content-end">
        <Button
          variant="link"
          size="sm"
          className="icon-button--link icon-button-lg btn-plus"
          onClick={handleClick}
        >
          Continue with new account
        </Button>
      </div>
      {existingUser && <SelectedUser user={existingUser} />}
    </Stack>
  )
}
